import React, { useState, useEffect, useRef } from 'react';
import { getData, imageUrl, postData } from '../../services/apiService';
import {
    Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography,
    IconButton, Button, TextField, Autocomplete, Stack, CardMedia, CardContent, Card, Avatar, List, ListItem, ListItemText, LinearProgress
} from '@mui/material';
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
import GridViewIcon from "@mui/icons-material/GridView";
import SearchIcon from "@mui/icons-material/Search";
import ViewListIcon from "@mui/icons-material/ViewList";
import MenuBookOutlined from '@mui/icons-material/MenuBookOutlined';
import PlayArrow from '@mui/icons-material/PlayArrow';
import AssignmentOutlined from '@mui/icons-material/AssignmentOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Layout from '../../components/layout/Layout';
import Progress from '../../hooks/useProgressBar';
import DataNotFound from '../../components/DataNotFound'
import useFetchIp from '../../hooks/useFetchIp';
import Hls from "hls.js";




const MyCourses = () => {
    const [loading, setLoading] = useState(true);
    const [courses, setCourses] = useState([]);
    const isFetched = useRef(false);
    const [viewPage, setViewPage] = useState(false);
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [selectedLesson, setSelectedLesson] = useState(null);
    const [courseProgress, setCourseProgress] = useState(null);
    const [viewMode, setViewMode] = useState("grid");
    const [expandedChapter, setExpandedChapter] = useState(null);
    const { ip } = useFetchIp();

    // inside your component
    const videoRef = useRef(null);

    // useEffect(() => {
    //     if (selectedLesson?.type === "video" && selectedLesson.content) {
    //         if (Hls.isSupported()) {
    //             const hls = new Hls();
    //             hls.loadSource(selectedLesson.content); // <-- yaha .m3u8 URL aayega
    //             hls.attachMedia(videoRef.current);
    //         } else if (videoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
    //             videoRef.current.src = selectedLesson.content;
    //         }
    //     }
    // }, [selectedLesson]);

    // useEffect(() => {
    //     let hls;
    //     if (selectedLesson?.type === "video" && selectedLesson.content) {
    //         if (Hls.isSupported()) {
    //             hls = new Hls();
    //             hls.loadSource(selectedLesson.content);
    //             hls.attachMedia(videoRef.current);
    //         } else if (videoRef.current.canPlayType("application/vnd.apple.mpegurl")) {
    //             videoRef.current.src = selectedLesson.content;
    //         }
    //     }
    //     return () => {
    //         if (hls) {
    //             hls.destroy();
    //         }
    //     };
    // }, [selectedLesson]);

    useEffect(() => {
        let hls;
        let blobUrl;
    
        if (selectedLesson?.type === "video" && selectedLesson?.content) {
            if (Hls.isSupported()) {
                hls = new Hls();
    
                
                if (selectedLesson?.content.startsWith("#EXTM3U")) {
                    const blob = new Blob([selectedLesson?.content], {
                        type: "application/vnd.apple.mpegurl",
                    });
                    blobUrl = URL.createObjectURL(blob);
                    hls.loadSource(blobUrl);
                } else {
                  
                    hls.loadSource(selectedLesson?.content);
                }
    
                hls.attachMedia(videoRef?.current);
            } else if (videoRef?.current.canPlayType("application/vnd.apple.mpegurl")) {
                if (selectedLesson?.content.startsWith("#EXTM3U")) {
                    const blob = new Blob([selectedLesson?.content], {
                        type: "application/vnd.apple.mpegurl",
                    });
                    blobUrl = URL.createObjectURL(blob);
                    videoRef.current.src = blobUrl;
                } else {
                    videoRef.current.src = selectedLesson?.content;
                }
            }
        }
    
        return () => {
            if (hls) hls.destroy();
            if (blobUrl) URL.revokeObjectURL(blobUrl);
        };
        // return () => {
        //     if (hls) {
        //         hls.destroy();
        //     }
        //     if (blobUrl) {
        //         URL.revokeObjectURL(blobUrl); // memory leak avoid करने के लिए
        //     }
        // };
    }, [selectedLesson]);
    


    // page load
    useEffect(() => {
        if (!isFetched.current) {
            fetchCourses();
            isFetched.current = true;
        }
    }, []);

    // Fetch all enrolled courses
    const fetchCourses = async () => {
        setLoading(true);
        try {
            const response = await getData('/get-all-enrolled-courses');
            setCourses(response);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching courses:', error);
            setLoading(false);
        }
    };

    // Fetch course progress when viewing a course
    // const viewCourse = async (courseId) => {
    //     setLoading(true);
    //     try {
    //         setViewPage(true);
    //         const response = await getData(`/get-course-section-and-lesson/${courseId}`);
    //         setSelectedCourse(response);
    //         setLoading(false);
    //         if (response.sections && response.sections.length > 0 &&
    //             response.sections[0].lessons && response.sections[0].lessons.length > 0) {
    //             setSelectedLesson(response.sections[0].lessons[0]);
    //             setExpandedChapter(response.sections[0]._id);
    //         } else {
    //             setSelectedLesson(null);
    //         }

    //         const progressResponse = await getData(`/get-course-progress/${courseId}`);
    //         setCourseProgress(progressResponse);
    //     } catch (error) {
    //         console.error('Error fetching course:', error);
    //         setLoading(false);
    //     }
    // };

    const viewCourse = async (courseId) => {
        setLoading(true);
        try {
            setViewPage(true);
            const response = await getData(`/get-course-section-and-lesson/${courseId}`);
            setSelectedCourse(response);

            if (response.sections && response.sections.length > 0 &&
                response.sections[0].lessons && response.sections[0].lessons.length > 0) {

                const firstSection = response.sections[0];
                const firstLesson = firstSection.lessons[0];

                setSelectedLesson(firstLesson);
                setExpandedChapter(firstSection._id);

                // Prefetch first lesson content so it shows by default
                if (!firstLesson.content) {
                    fetchLessonContent(firstLesson._id).then((contentResponse) => {
                        setSelectedLesson(prev => {
                            if (!prev || prev._id !== firstLesson._id) return prev;
                            return { ...prev, ...contentResponse };
                        });
                    });
                }
            } else {
                setSelectedLesson(null);
            }

            const progressResponse = await getData(`/get-course-progress/${courseId}`);
            setCourseProgress(progressResponse);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching course:', error);
            setLoading(false);
        }
    };

     // Fetch lesson content lazily
     const fetchLessonContent = async (lessonId) => {
        try {
            const response = await getData(`/get-lesson-content/${lessonId}`);
            return response;
        } catch (error) {
            console.error("Error loading lesson content:", error);
            return { content: null, error: "Failed to load content" };
        }
    };

    // Handle lesson click
    const handleLessonClick = async (lesson, sectionIndex, lessonIndex) => {
        if (!isLessonUnlocked(lesson, sectionIndex, lessonIndex)) {
            return;
        }

        setSelectedLesson(lesson);

        // Lazy load if no content
        if (!lesson.content) {
            const contentResponse = await fetchLessonContent(lesson._id);
            setSelectedLesson(prev => ({ ...prev, ...contentResponse }));
        }
    };

    // Check if a lesson is unlocked
    const isLessonUnlocked = (lesson, sectionIndex, lessonIndex) => {
        if (!courseProgress) return false;

        // First lesson is always unlocked
        if (sectionIndex === 0 && lessonIndex === 0) return true;

        // Check if previous lesson is completed
        const allLessons = [];
        selectedCourse.sections.forEach(section => {
            section.lessons.forEach(l => allLessons.push(l));
        });

        const currentLessonIndex = allLessons.findIndex(l => l._id === lesson._id);
        if (currentLessonIndex === 0) return true;

        const previousLesson = allLessons[currentLessonIndex - 1];
        return courseProgress.completedLessons.includes(previousLesson._id);
    };

    // Mark lesson as completed
    const markLessonCompleted = async (lessonId) => {
        try {
            await postData('/mark-lesson-completed', {
                courseId: selectedCourse.course._id,
                lessonId: lessonId,
                ipAddress: ip
            });

            // Update local progress state
            const updatedCompletedLessons = [...courseProgress.completedLessons, lessonId];

            // Check if all lessons are completed
            const allLessons = [];
            selectedCourse.sections.forEach(section => {
                section.lessons.forEach(l => allLessons.push(l));
            });

            const isCompleted = allLessons.every(lesson =>
                updatedCompletedLessons.includes(lesson._id)
            );

            setCourseProgress(prev => ({
                ...prev,
                completedLessons: updatedCompletedLessons,
                isCompleted: isCompleted
            }));
        } catch (error) {
            console.error('Error marking lesson as completed:', error);
        }
    };

    // Handle lesson click with unlock check
    // const handleLessonClick = (lesson, sectionIndex, lessonIndex) => {
    //     if (!isLessonUnlocked(lesson, sectionIndex, lessonIndex)) {
    //         return; // Don't allow clicking locked lessons
    //     }
    //     setSelectedLesson(lesson);
    // };

    const handleChapterChange = (panel) => {
        setExpandedChapter(expandedChapter === panel ? null : panel);
    };

    const calculateSectionProgress = (section) => {
        if (!courseProgress) return 0;
        const completedLessons = section.lessons.filter(lesson =>
            courseProgress.completedLessons.includes(lesson._id)
        ).length;
        return Math.round((completedLessons / section.lessons.length) * 100) || 0;
    };

    return (
        <Layout>
            {loading ? <Progress /> :
                <Box className="p-6 bg-gray-100 min-h-screen">
                    {viewPage === false && (
                        <Box>
                            <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold', mb: 3 }}>MY Course's</Typography>

                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 2, }}>
                                <Box sx={{ flexGrow: 1, maxWidth: 350 }}>
                                    <Autocomplete freeSolo options={[]} renderInput={(params) => (
                                        <TextField
                                            {...params} placeholder="Search Courses" variant="outlined" fullWidth
                                            InputProps={{
                                                ...params.InputProps,
                                                startAdornment: (
                                                    <SearchIcon sx={{ color: "text.secondary", mr: 1 }} />
                                                ),
                                            }}
                                            sx={{ bgcolor: "#d9d9d9", "& .MuiOutlinedInput-root": { borderColor: "#c9c9c9", }, }}
                                        />
                                    )}
                                    />
                                </Box>
                                <Box sx={{ display: "flex", ml: 2 }}>
                                    <IconButton onClick={() => setViewMode("grid")} sx={{ color: viewMode === "grid" ? "#3a3899" : "text.secondary", }} >
                                        <GridViewIcon />
                                    </IconButton>
                                    <IconButton onClick={() => setViewMode("list")} sx={{ color: viewMode === "list" ? "#3a3899" : "text.secondary", }} >
                                        <ViewListIcon />
                                    </IconButton>
                                </Box>
                            </Box>

                            {courses.length === 0 ? (
                                // <Box sx={{ textAlign: 'center', py: 6 }}>
                                //     <Typography variant="h6" sx={{ mb: 2 }}>
                                //         No available courses to enroll at the moment.
                                //     </Typography>
                                //     <Link to="/dashboard" style={{ color: '#1976d2', textDecoration: 'none' }}>
                                //         Go back to dashboard
                                //     </Link>
                                // </Box>
                                <DataNotFound></DataNotFound>

                            ) : viewMode === 'grid' ? (
                                <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)", }, gap: 2, }} >
                                    {courses.map(course => (
                                        <Card sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", borderRadius: 1, position: "relative" }}>
                                            <CardMedia component="img" height="150" image={course?.course?.thumbnail} alt={course.course.title} sx={{ p: 0.5, objectFit: "cover" }} />
                                            <CardContent sx={{ pt: 1, flexGrow: 1, display: "flex", flexDirection: "column" }}>
                                                <Typography variant="subtitle1" fontFamily="Poppins, Helvetica" fontWeight="500" fontSize="15px" textAlign="left" gutterBottom >
                                                    <b>{course.course.courseName}</b>
                                                </Typography>

                                                <Typography variant="body2" fontFamily="Poppins, Helvetica" color="#074e11" textAlign="left" sx={{ mb: 1 }} >
                                                    {course.course.instructor?.firstName} {course.course.instructor?.lastName}
                                                </Typography>

                                                {course.course.department_id && (
                                                    <Typography variant="body2" fontFamily="Poppins, Helvetica" color="text.secondary" sx={{ mb: 1 }} >
                                                        Department: {course.course.department_id.name}
                                                    </Typography>
                                                )}

                                                <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                                    <Typography variant="body2" fontFamily="Poppins, Helvetica" color="text.secondary" >
                                                        {course.course.description || 'Description not specified'}
                                                    </Typography>
                                                </Stack>
                                                {/* <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                                    <AccessTimeIcon fontSize="small" color="action" />
                                                    <Typography variant="body2" fontFamily="Poppins, Helvetica" color="text.secondary" >
                                                        {course.course.description || 'Description not specified'}
                                                    </Typography>
                                                </Stack> */}

                                                <Box display="flex" justifyContent="space-between" alignItems="center" mt="auto" >
                                                    <Stack direction="row" spacing={1}>
                                                        <Typography variant="body2" fontFamily="Poppins, Helvetica" fontWeight="500" >
                                                            {'₹' + course.course.amount || 'Free'}
                                                        </Typography>
                                                    </Stack>
                                                    <Button variant="contained" onClick={() => viewCourse(course.course._id)}
                                                        sx={{
                                                            backgroundColor: '#4B49AC', '&:hover': { backgroundColor: '#3a3899', },
                                                            textTransform: "none", borderRadius: 0, width: 136, height: 40, fontFamily: "Poppins, Helvetica", fontWeight: 500,
                                                        }} >
                                                        View
                                                    </Button>
                                                </Box>
                                            </CardContent>
                                        </Card>
                                    ))}
                                </Box>
                            ) : (
                                <Box>
                                    <TableContainer component={Paper} elevation={0} sx={{ mb: 2, borderRadius: 2, boxShadow: 2, overflow: 'hidden', }} >
                                        <Table>
                                            <TableHead>
                                                <TableRow sx={{ bgcolor: '#4B49AC' }}>
                                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600, borderTopLeftRadius: 8 }}> ID </TableCell>
                                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Course Name </TableCell>
                                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Code </TableCell>
                                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Title </TableCell>
                                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Course Type </TableCell>
                                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> start Date </TableCell>
                                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> End Date </TableCell>
                                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Status </TableCell>
                                                    <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Action </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {courses.map((course, index) => (
                                                    <TableRow key={course.course._id}>
                                                        <TableCell align="center">
                                                            <Typography variant="body1">{index + 1}</Typography>
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <Typography variant="body1" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                <img src={course?.course?.thumbnail} alt={course.course.courseName} style={{ width: 50, height: 50, borderRadius: '50%' }} /> {course.course.courseName}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <Typography variant="body1">{course.course.code}</Typography>
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <Typography variant="body1">{course.course.title}</Typography>
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <Typography variant="body1">{course.course.Type}</Typography>
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <Typography variant="body1">{new Date(course.course.startDate).toLocaleDateString()}</Typography>
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <Typography variant="body1">{new Date(course.course.endDate).toLocaleDateString()}</Typography>
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <Typography variant="body1">{course.course.status}</Typography>
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <Typography variant="body1"><Button variant="contained" onClick={() => viewCourse(course.course._id)}
                                                                sx={{
                                                                    backgroundColor: '#4B49AC', '&:hover': { backgroundColor: '#3a3899', },
                                                                    textTransform: "none", borderRadius: 0, width: 136, height: 40, fontFamily: "Poppins, Helvetica", fontWeight: 500,
                                                                }} >
                                                                View
                                                            </Button></Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            )}
                        </Box>
                    )}
                    {viewPage === true && (
                        <Box>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 2, }}>
                                <Box sx={{ flexGrow: 1, maxWidth: 350 }}>
                                    <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold', mb: 3 }}> Courses Details</Typography>
                                </Box>
                                <Box sx={{ display: "flex", ml: 2 }}>
                                    <Button variant="contained" onClick={() => setViewPage(false)}
                                        sx={{
                                            backgroundColor: '#4B49AC', '&:hover': { backgroundColor: '#3a3899' }, textTransform: "none", borderRadius: '12px 12px 12px 12px', // top-left, top-right, bottom-right, bottom-left
                                            width: 136, height: 40, fontFamily: "Poppins, Helvetica", fontWeight: 500,
                                        }} >
                                        Back
                                    </Button>
                                </Box>
                            </Box>
                            {/* Course Content */}
                            <Paper sx={{ width: "100%", borderRadius: "10px 10px 0 0", overflow: "auto", maxHeight: "calc(100vh - 70px)", p: 3 }}>
                                <Stack direction={{ xs: "column", md: "row" }} spacing={3}>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography variant="h5" component="h1" fontWeight="bold" gutterBottom>
                                            {selectedCourse?.course?.title}
                                        </Typography>
                                        <Typography variant="body1" color="text.secondary" paragraph>
                                            {selectedCourse?.course?.description}
                                        </Typography>
                                        <Stack direction="row" spacing={3} alignItems="center" sx={{ mb: 2 }}>
                                            <Stack direction="row" spacing={1} alignItems="center">
                                                {/* <Avatar src={`${imageUrl}${selectedCourse?.course?.instructor?.profileImage}`} alt={selectedCourse?.course?.instructor?.firstName} sx={{ width: 40, height: 40 }} /> */}
                                                <Typography variant="body2" fontWeight="medium" color="text.secondary">
                                                    {selectedCourse?.course?.instructor?.firstName} {selectedCourse?.course?.instructor?.lastName}
                                                </Typography>
                                            </Stack>
                                            <Stack direction="row" spacing={1} alignItems="center">
                                                <MenuBookOutlined fontSize="small" color="action" />
                                                <Typography variant="body2" fontWeight="medium" color="text.secondary">
                                                    Course Code: {selectedCourse?.course?.code}
                                                </Typography>
                                            </Stack>
                                        </Stack>
                                        {/* <Stack direction="row" spacing={4} sx={{ mb: 3 }}>
                                            <Typography variant="body2" color="text.secondary">Start: {new Date(selectedCourse?.course?.startDate).toLocaleDateString()}</Typography>
                                            <Typography variant="body2" color="text.secondary">End: {new Date(selectedCourse?.course?.endDate).toLocaleDateString()}</Typography>
                                        </Stack> */}
                                    </Box>
                                    <Box component="img" src={selectedCourse?.course?.thumbnail} alt="Course Preview"
                                        sx={{ width: { xs: "100%", md: "405px" }, height: "225px", objectFit: "cover", borderRadius: 1, }} />
                                </Stack>

                                <Typography variant="h6" fontWeight="600" sx={{ mt: 4, mb: 2 }}>
                                    Course Contents
                                </Typography>
                                <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
                                    <Box sx={{ flex: 1, bgcolor: "#f0f0f0", borderRadius: 2, p: 1 }}>
                                        {selectedCourse?.sections?.map((section, sectionIndex) => (
                                            <Paper key={section._id} elevation={1}
                                                sx={{ mb: 2, overflow: 'hidden', '&:last-child': { mb: 0 }, }} >
                                                <Button fullWidth onClick={() => handleChapterChange(section._id)}
                                                    sx={{ justifyContent: 'flex-start', textAlign: 'left', p: 2, bgcolor: 'background.paper', }} >
                                                    <Box sx={{ width: '100%' }}>
                                                        <Typography variant="subtitle2" fontWeight="600" sx={{ color: '#3a3899' }} >
                                                            Chapter {sectionIndex + 1}: {section.title}
                                                        </Typography>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                                                            <Box sx={{ width: '100%', mr: 1 }}>
                                                                <LinearProgress
                                                                    variant="determinate"
                                                                    value={calculateSectionProgress(section)}
                                                                    sx={{ height: 7, bgcolor: '#3a3899', borderRadius: 1, '& .MuiLinearProgress-bar': { bgcolor: '#3a3899', }, }} />
                                                            </Box>
                                                            <Typography variant="subtitle2" color="text.secondary">
                                                                {calculateSectionProgress(section)}%
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                    <ExpandMoreIcon sx={{ transform: expandedChapter === section._id ? 'rotate(180deg)' : 'rotate(0deg)', transition: '0.3s', color: '#3a3899', }} />
                                                </Button>
                                                {expandedChapter === section._id && (
                                                    <List disablePadding sx={{ bgcolor: 'background.paper', p: 2 }}>
                                                        {section.lessons.map((lesson, lessonIndex) => (
                                                            <ListItem
                                                                key={lesson._id}
                                                                onClick={() => handleLessonClick(lesson, sectionIndex, lessonIndex)}
                                                                sx={{
                                                                    mb: 1, border: '1px solid #acacac', borderRadius: '4px', '&:last-child': { mb: 0 },
                                                                    cursor: isLessonUnlocked(lesson, sectionIndex, lessonIndex) ? 'pointer' : 'not-allowed',
                                                                    opacity: isLessonUnlocked(lesson, sectionIndex, lessonIndex) ? 1 : 0.5,
                                                                }} >
                                                                <ListItemText
                                                                    primary={lesson.title}
                                                                    secondary={`${lesson.duration || '0'} min`}
                                                                    primaryTypographyProps={{ variant: 'body2', fontWeight: 'medium', }}
                                                                    secondaryTypographyProps={{ variant: 'caption', color: 'text.secondary', fontWeight: 'medium', }} />
                                                                {lesson.type === 'video' ? (
                                                                    <PlayArrow color="action" />
                                                                ) : lesson.type === 'quiz' ? (
                                                                    <AssignmentOutlined color="action" />
                                                                ) : (
                                                                    <MenuBookOutlined color="action" />
                                                                )}
                                                            </ListItem>
                                                        ))}
                                                    </List>
                                                )}
                                            </Paper>
                                        ))}
                                    </Box>
                                    <Box
                                        sx={{ width: { xs: "100%", md: "950px" }, bgcolor: "#f0f0f0", borderRadius: 2, p: 1, display: "flex", justifyContent: "center", alignItems: "flex-start", }} >
                                        {selectedLesson ? (
                                            <Box sx={{ width: "100%" }}>
                                                <div className="flex justify-between items-center mb-6">
                                                    <h3 className="text-2xl font-semibold">{selectedLesson.title}</h3>
                                                    <div className="flex items-center space-x-3">
                                                        <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">
                                                            {selectedLesson.type.toUpperCase()}
                                                        </span>
                                                        {!courseProgress?.completedLessons.includes(selectedLesson._id) &&
                                                            (selectedLesson.type === 'text' || selectedLesson.type === 'pdf') && (
                                                                <button onClick={() => markLessonCompleted(selectedLesson._id)}
                                                                    className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors"
                                                                >
                                                                    Mark Complete
                                                                </button>
                                                            )}
                                                    </div>
                                                </div>

                                                {selectedLesson.type === 'text' && (
                                                    <div className="prose max-w-none">
                                                        <p className="text-gray-700">{selectedLesson.content}</p>
                                                    </div>
                                                )}
                                                {/* {selectedLesson.type === 'video' && (
                                                    <video
                                                        controls
                                                        src={selectedLesson.content}
                                                        style={{ width: "100%", borderRadius: "4px" }}
                                                        onEnded={() => {
                                                            if (!courseProgress?.completedLessons.includes(selectedLesson._id)) {
                                                                markLessonCompleted(selectedLesson._id);
                                                            }
                                                        }}
                                                    />
                                                )} */}
                                                {/* {selectedLesson.type === 'video' && (
                                                    <video
                                                        controls
                                                        controlsList="nodownload"  // Add this attribute
                                                        src={selectedLesson.content}
                                                        style={{ width: "100%", borderRadius: "4px" }}
                                                        onEnded={() => {
                                                            if (!courseProgress?.completedLessons.includes(selectedLesson._id)) {
                                                                markLessonCompleted(selectedLesson._id);
                                                            }
                                                        }}
                                                    />
                                                )} */}
                                                {selectedLesson.type === 'video' && (
                                                    <div>
                                                        {selectedLesson.content ? (
                                                            <video
                                                                ref={videoRef}
                                                                controls
                                                                controlsList="nodownload"
                                                                style={{ width: "100%", borderRadius: "4px" }}
                                                                onEnded={() => {
                                                                    if (!courseProgress?.completedLessons.includes(selectedLesson?._id)) {
                                                                        markLessonCompleted(selectedLesson?._id);
                                                                    }
                                                                }}
                                                            />
                                                        ) : (
                                                            <div style={{ 
                                                                width: "100%", 
                                                                height: "300px", 
                                                                display: "flex", 
                                                                alignItems: "center", 
                                                                justifyContent: "center",
                                                                backgroundColor: "#f5f5f5",
                                                                borderRadius: "4px",
                                                                border: "2px dashed #ccc"
                                                            }}>
                                                                <div style={{ textAlign: "center" }}>
                                                                    <Typography variant="h6" color="text.secondary">
                                                                        {selectedLesson.error || "Video is being processed..."}
                                                                    </Typography>
                                                                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                                                                        {/* Please check back in a few minutes */}
                                                                        <Progress />
                                                                    </Typography>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                                

                                                {selectedLesson.type === 'pdf' && (
                                                    <iframe
                                                        src={`${selectedLesson.content}#toolbar=0&navpanes=0`}
                                                        style={{ width: "100%", height: "500px", border: "none" }}
                                                    />
                                                )}
                                                {/* {selectedLesson.type === 'pdf' && (
                                                    <iframe
                                                        src={selectedLesson.content}
                                                        style={{ width: "100%", height: "500px", border: "none" }}
                                                    />
                                                )} */}
                                                {selectedLesson.type === 'quiz' && (

                                                    <Box sx={{ p: 2 }}>
                                                        <Typography variant="h6" gutterBottom> Quiz: {selectedLesson.title} </Typography>
                                                        <Button variant="contained" color="primary"
                                                            onClick={() => {
                                                                markLessonCompleted(selectedLesson._id);
                                                                window.open(`/quiz-submission?quizId=${selectedLesson.content}`, '_blank');
                                                            }}
                                                        > Start Quiz
                                                        </Button>
                                                    </Box>

                                                )}
                                            </Box>
                                        ) : (
                                            <Box component="img" src={selectedCourse?.course?.thumbnail} alt="Course Preview Video"
                                                sx={{ width: "510px", maxWidth: "100%", borderRadius: 1, }} />
                                        )}
                                    </Box>
                                </Stack>
                            </Paper>
                        </Box>
                    )}
                </Box>
            }
        </Layout >
    );
};

export default MyCourses;